export default __webpack_public_path__ + "static/media/mr_mrs_smith_l3.047c4ee7.png";